import * as actionTypes from './actionTypes';
import { GeneralModel } from '@app/src/views/StepTwo/channelPublication/models/print';

interface State {
  general: GeneralModel;
  isFetching: boolean;
  error: boolean;
  summaryId: string;
  printsByChannel: any;
}

const initialState: State = {
  general: {},
  isFetching: false,
  error: false,
  summaryId: '',
  printsByChannel: {}
};

export const print = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_PRINT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_PRINT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_PRINT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        summaryId: action.id
      }
    case actionTypes.SET_PRINT_GENERAL:
      return {
        ...state,
        general: { ...action.data }
      }
    case actionTypes.SET_PRINT_DATA:
      return {
        ...action.data
      }
    case actionTypes.SET_PRINT_ALL_BY_CHANNEL:
      let channels = {};
      channels[action.id] = action.data;
      return {
        ...state,
        printsByChannel: {
          ...state.printsByChannel,
          ...channels
        }
      }
    case actionTypes.DELETE_PRINT_ALL_BY_CHANNEL:
      let currentChannels = state.printsByChannel;
      currentChannels[action.id] = [];
      return {
        ...state,
        printsByChannel: { ...currentChannels }
      }
    case actionTypes.CLEAN_PRINT_GENERAL:
      return {
        ...state,
        general: {}
      }
    case actionTypes.CLEAN_PRINT_SUMMARY_ID:
      return {
        ...state,
        summaryId: ''
      }
    case actionTypes.SET_PRINT_EXTRAWORDS:
      return {
        ...state,
      }
    case actionTypes.CLEAR_PRINT_DATA:
      return {
        ...state,
        summaryId: '',
        printsByChannel: {},
      }
    default:
      return state;
  }
};
